export default "__VITE_ASSET__b14a1da7__"